module.exports = __webpack_public_path__ + "static/media/Organization_4.0abf5ec3.svg";